var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-item flex f-ai",class:_vm.activeClass ? 'active-class' : '',on:{"click":_vm.onClick}},[_c('b-icon',{style:(_vm.style),attrs:{"icon":_vm.icon}}),_c('p',[_vm._v(_vm._s(_vm.item.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }